import { productAnalitica } from "@/app/(store)/_utils/events";
import { share } from "@/app/(store)/_utils/share";
import { useStore } from "@/contexts/store";
import { MessageBuilder } from "@/utils/message-builder";
import { useProductStore } from "@/stores";
import { CopyShareButton, WhatsappShareButton } from "@/components";

type Props = {
  loading: boolean;
};

export const ProductShareActions = ({ loading }: Props) => {
  const { product, price, chosenVariants } = useProductStore();
  const { enabledWhatsAppSharing, store } = useStore();

  const productUrl = `${global.window?.location.origin}/${store.identifier}/produto/${product.id}`;

  const onShare = () => {
    productAnalitica.events.share.whatsapp();

    const text = MessageBuilder.buildProductMessage({
      productName: product.name,
      price,
      chosenVariants,
      link: productUrl,
    });

    share.whatsapp(store.vitrine.whatsAppNumber!, text);
  };

  const onShareLink = () => productAnalitica.events.share.link();

  return (
    <div className="flex w-full flex-col gap-3 lg:flex-row lg:gap-5">
      <CopyShareButton
        loading={loading}
        text={product.name}
        url={productUrl}
        onShare={onShareLink}
        className="flex-[1 1 auto] lg:flex-1"
        variant="neutral-subtle"
      />

      {enabledWhatsAppSharing ? (
        <WhatsappShareButton loading={loading} onClick={onShare} />
      ) : null}
    </div>
  );
};
